<template>
  <main class="d-flex flex-column flex-grow-1 align-items-center justify-content-center bg-primary">
    <div class="container py-3 py-sm-4">
      <navbar v-if="page > 0" :page="page" :maxPage="maxPage" @proceed="page = $event" />
      <welcome v-if="page === 0" :name="user ? user.first_name : ''" @proceed="page = 1" />
      <page1 v-if="page === 1" :user="user" @proceed="page = 2" />
      <page2 v-if="page === 2" :user="user" @proceed="page = 3" />
      <page4 v-if="page === 3" :user="user" @proceed="page = $event" />
    </div>
  </main>
</template>

<script>
import navbar from './LoginOnceNav'
import welcome from './LoginOnceWelcome'
import page1 from './LoginOnce1'
import page2 from './LoginOnce2'
// import page3 from './LoginOnce3'
import page4 from './LoginOnce4'

export default {
  props: ['userDetails'],
  name: 'LoginOnce',
  components: {
    navbar,
    welcome,
    page1,
    page2,
    // page3,
    page4
  },
  data() {
    return {
      success: false,
      errors: '',
      errorStatus: '',
      responseStatus: '',
      page: 0,
      maxPage: 0,
      user: this.userDetails
    }
  },
  mounted() {
    if (this.userDetails === undefined) {
      if (localStorage.userDetails) {
        this.user = JSON.parse(localStorage.userDetails)
      } else {
        this.$router.push('/login')
      }
    }
  },
  watch: {
    page() {
      this.maxPage = Math.max(this.page, this.maxPage)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 897px;
}
</style>



// WEBPACK FOOTER //
// src/views/Account/LoginOnce/LoginOnce.vue